<script lang="ts" setup>
  defineProps<{
    disable?: boolean
    modelValue: boolean
  }>()

  defineEmits<{
    (e: 'update:modelValue', value: boolean): void
  }>()
</script>

<template>
  <QCheckbox
    :model-value="modelValue"
    :disable="disable"
    dense
    class="base-checkbox flex! items-start!"
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <slot />
  </QCheckbox>
</template>

<style lang="scss" scoped>
  .base-checkbox {
    &[aria-checked='true'] {
      :deep() {
        .q-checkbox__inner {
          color: var(--component-base-checkbox-color-checked);
        }
        .q-checkbox__bg {
          border-radius: 5px;
          border: 1px solid var(--component-base-checkbox-color-checked);
        }
        .q-checkbox__truthy {
          stroke: var(--text-inverse);
        }
      }
    }
    :deep() {
      .q-checkbox__bg {
        border-radius: 5px;
        border: 1px solid var(--component-base-checkbox-color);
      }
      .q-checkbox__label {
        padding-left: 0;
        margin-left: 12px;
      }
    }
  }
</style>
